const AuthHeader = ({ portalSettings }) => {

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const baseURL = import.meta.env.VITE_APP_BASE;

    // If loading auth or no portal settings yet, just render nothing
    if (!portalSettings) return null;

    const psm = portalSettings || {};

    return (
        <div className="auth-header">
            <img
                src={`https://insuranceservices.actmanre.com/AMRImages/${psm.groupCode}/${psm.companyLogo}`}
                alt="Company Logo"
                style={{ height: '80px', objectFit: 'contain' }}
                className="auth-logo"
            />
        </div>
    )
}

export default AuthHeader;